export const STORE_LOCATER = /* GraphQL */ `
    query StoreLocator($searchTerm: String, $storeTypeFilter: [String]) {
        storeLocator(
            pageSize: 100
            filter: {
                store_type_filter: { in: $storeTypeFilter }
                is_active: { eq: "1" }
                search_key: { like: $searchTerm }
            }
        ) {
            total_count
            is_enable
            google_map_api
            page_title
            meta_description
            is_active
            meta_keyword
            items {
                address
                city
                conditions
                country_id
                description
                is_active
                latitude
                longitude
                meta_description
                meta_keywords
                meta_title
                region
                region_id
                storeemail
                storeimage
                storelocator_id
                storename
                storetime
                telephone
                website_url
                zipcode
                store_tag
                google_map_link
                store_type_filter
            }
        }
    }
`
